import { render } from "./Recipe2View.vue?vue&type=template&id=73feef5c&scoped=true"
import script from "./Recipe2View.vue?vue&type=script&lang=js"
export * from "./Recipe2View.vue?vue&type=script&lang=js"

import "./Recipe2View.vue?vue&type=style&index=0&id=73feef5c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73feef5c"]])

export default __exports__